import { useState } from 'react';

import Grid from '@zenbusiness/zui/Grid';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { formatStringWithOnlyDot } from '#client/utils/text';

const eyeShow = (
  <SharedAsset
    alt=""
    height={24}
    src="/icon/micro/eye-simple-show.svg"
    width={24}
  />
);
const eyeHide = (
  <SharedAsset
    alt=""
    height={24}
    src="/icon/micro/eye-simple-hide.svg"
    width={24}
  />
);
export default function AccountDetail({
  label,
  accountNumber,
  fullAccountNumber,
  loading,
  xs = 12,
  lg = 4
}) {
  const [show, setShow] = useState(false);
  const hiddenValue = accountNumber ? formatStringWithOnlyDot(accountNumber) : '';

  const handleClick = () => {
    setShow((isShow) => !isShow);
  };

  return (
    <Grid
      item
      lg={lg}
      xs={xs}
    >
      <Stack
        direction="column"
        gap="8px"
      >
        <Text
          color="secondary"
          size="xs"
          uppercase
        >
          {label}
        </Text>
        {!accountNumber || loading ? (
          <Skeleton />
        ) : (
          <Stack
            alignItems="center"
            direction="row"
          >
            <Text size="lg">{show ? fullAccountNumber : hiddenValue}</Text>
            {fullAccountNumber && (
              <Stack
                alignItems="center"
                aria-label="eyes-switch"
                onClick={handleClick}
              >
                {show ? eyeHide : eyeShow}
              </Stack>
            )}
          </Stack>
        )}
      </Stack>
    </Grid>
  );
}

AccountDetail.propTypes = {
  label: PropTypes.string.isRequired,
  accountNumber: PropTypes.string,
  fullAccountNumber: PropTypes.string,
  loading: PropTypes.bool,
  xs: PropTypes.number,
  lg: PropTypes.number
};
